(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[747],{

/***/ 5235:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath = (/* unused pure expression or super */ null && ( false || ''));

function getDomainLocale(path, locale, locales, domainLocales) {
  if (false) { var finalLocale, proto, domain, target, detectDomainLocale, normalizeLocalePath; } else {
    return false;
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 7913:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

var _slicedToArray = __webpack_require__(5696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _object_without_properties_loose = (__webpack_require__(7273)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(7294));

var _router = __webpack_require__(2199);

var _addLocale = __webpack_require__(1630);

var _routerContext = __webpack_require__(9541);

var _appRouterContext = __webpack_require__(6163);

var _useIntersection = __webpack_require__(6457);

var _getDomainLocale = __webpack_require__(5235);

var _addBasePath = __webpack_require__(729);

'use client';
var prefetched = {};

function prefetch(router, href, as, options) {
  if ( false || !router) return;
  if (!(0, _router).isLocalURL(href)) return; // Prefetch the JSON page if asked (only in the client)
  // We need to handle a prefetch error here since we may be
  // loading with priority which can reject but we don't
  // want to force navigation since this is only a prefetch

  Promise.resolve(router.prefetch(href, as, options))["catch"](function (err) {
    if (false) {}
  });
  var curLocale = options && typeof options.locale !== 'undefined' ? options.locale : router && router.locale; // Join on an invalid URI character

  prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')] = true;
}

function isModifiedEvent(event) {
  var target = event.currentTarget.target;
  return target && target !== '_self' || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}

function linkClicked(e, router, href, as, replace, shallow, scroll, locale, isAppRouter, prefetchEnabled) {
  var nodeName = e.currentTarget.nodeName; // anchors inside an svg have a lowercase nodeName

  var isAnchorNodeName = nodeName.toUpperCase() === 'A';

  if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
    // ignore click for browser’s default behavior
    return;
  }

  e.preventDefault();

  var navigate = function navigate() {
    // If the router is an NextRouter instance it will have `beforePopState`
    if ('beforePopState' in router) {
      router[replace ? 'replace' : 'push'](href, as, {
        shallow: shallow,
        locale: locale,
        scroll: scroll
      });
    } else {
      // If `beforePopState` doesn't exist on the router it's the AppRouter.
      var method = replace ? 'replace' : 'push'; // Apply `as` if it's provided.

      router[method](as || href, {
        forceOptimisticNavigation: !prefetchEnabled
      });
    }
  };

  if (isAppRouter) {
    // @ts-expect-error startTransition exists.
    _react["default"].startTransition(navigate);
  } else {
    navigate();
  }
}
/**
 * React Component that enables client-side transitions between routes.
 */


var Link = /*#__PURE__*/_react["default"].forwardRef(function LinkComponent(props, forwardedRef) {
  if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }

  var children;

  var hrefProp = props.href,
      asProp = props.as,
      childrenProp = props.children,
      prefetchProp = props.prefetch,
      passHref = props.passHref,
      replace = props.replace,
      shallow = props.shallow,
      scroll = props.scroll,
      locale = props.locale,
      _onClick = props.onClick,
      _onMouseEnter = props.onMouseEnter,
      _onTouchStart = props.onTouchStart,
      _props$legacyBehavior = props.legacyBehavior,
      legacyBehavior = _props$legacyBehavior === void 0 ? Boolean(true) !== true : _props$legacyBehavior,
      restProps = _object_without_properties_loose(props, ["href", "as", "children", "prefetch", "passHref", "replace", "shallow", "scroll", "locale", "onClick", "onMouseEnter", "onTouchStart", "legacyBehavior"]);

  children = childrenProp;

  if (legacyBehavior && (typeof children === 'string' || typeof children === 'number')) {
    children = /*#__PURE__*/_react["default"].createElement("a", null, children);
  }

  var p = prefetchProp !== false;

  var router = _react["default"].useContext(_routerContext.RouterContext); // TODO-APP: type error. Remove `as any`


  var appRouter = _react["default"].useContext(_appRouterContext.AppRouterContext);

  if (appRouter) {
    router = appRouter;
  }

  var _react$default$useMem = _react["default"].useMemo(function () {
    var _resolveHref = (0, _router).resolveHref(router, hrefProp, true),
        _resolveHref2 = _slicedToArray(_resolveHref, 2),
        resolvedHref = _resolveHref2[0],
        resolvedAs = _resolveHref2[1];

    return {
      href: resolvedHref,
      as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
    };
  }, [router, hrefProp, asProp]),
      href = _react$default$useMem.href,
      as = _react$default$useMem.as;

  var previousHref = _react["default"].useRef(href);

  var previousAs = _react["default"].useRef(as); // This will return the first child, if multiple are provided it will throw an error


  var child;

  if (legacyBehavior) {
    if (false) {} else {
      child = _react["default"].Children.only(children);
    }
  } else {
    if (false) { var ref; }
  }

  var childRef = legacyBehavior ? child && typeof child === 'object' && child.ref : forwardedRef;

  var _useIntersection2 = (0, _useIntersection).useIntersection({
    rootMargin: '200px'
  }),
      _useIntersection3 = _slicedToArray(_useIntersection2, 3),
      setIntersectionRef = _useIntersection3[0],
      isVisible = _useIntersection3[1],
      resetVisible = _useIntersection3[2];

  var setRef = _react["default"].useCallback(function (el) {
    // Before the link getting observed, check if visible state need to be reset
    if (previousAs.current !== as || previousHref.current !== href) {
      resetVisible();
      previousAs.current = as;
      previousHref.current = href;
    }

    setIntersectionRef(el);

    if (childRef) {
      if (typeof childRef === 'function') childRef(el);else if (typeof childRef === 'object') {
        childRef.current = el;
      }
    }
  }, [as, childRef, href, resetVisible, setIntersectionRef]);

  _react["default"].useEffect(function () {
    var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale;
    var isPrefetched = prefetched[href + '%' + as + (curLocale ? '%' + curLocale : '')];

    if (shouldPrefetch && !isPrefetched) {
      prefetch(router, href, as, {
        locale: curLocale
      });
    }
  }, [as, href, isVisible, locale, p, router]);

  var childProps = {
    ref: setRef,
    onClick: function onClick(e) {
      if (false) {}

      if (!legacyBehavior && typeof _onClick === 'function') {
        _onClick(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onClick === 'function') {
        child.props.onClick(e);
      }

      if (!e.defaultPrevented) {
        linkClicked(e, router, href, as, replace, shallow, scroll, locale, Boolean(appRouter), p);
      }
    },
    onMouseEnter: function onMouseEnter(e) {
      if (!legacyBehavior && typeof _onMouseEnter === 'function') {
        _onMouseEnter(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onMouseEnter === 'function') {
        child.props.onMouseEnter(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    },
    onTouchStart: function onTouchStart(e) {
      if (!legacyBehavior && typeof _onTouchStart === 'function') {
        _onTouchStart(e);
      }

      if (legacyBehavior && child.props && typeof child.props.onTouchStart === 'function') {
        child.props.onTouchStart(e);
      } // Check for not prefetch disabled in page using appRouter


      if (!(!p && appRouter)) {
        if ((0, _router).isLocalURL(href)) {
          prefetch(router, href, as, {
            priority: true
          });
        }
      }
    }
  }; // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
  // defined, we specify the current 'href', so that repetition is not needed by the user

  if (!legacyBehavior || passHref || child.type === 'a' && !('href' in child.props)) {
    var curLocale = typeof locale !== 'undefined' ? locale : router && router.locale; // we only render domain locales if we are currently on a domain locale
    // so that locale links are still visitable in development/preview envs

    var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
    childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
  }

  return legacyBehavior ? /*#__PURE__*/_react["default"].cloneElement(child, childProps) : /*#__PURE__*/_react["default"].createElement("a", Object.assign({}, restProps, childProps), children);
});

var _default = Link;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 6457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = __webpack_require__(5696);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useIntersection = useIntersection;

var _react = __webpack_require__(7294);

var _requestIdleCallback = __webpack_require__(8065);

var hasIntersectionObserver = typeof IntersectionObserver === 'function';
var observers = new Map();
var idList = [];

function createObserver(options) {
  var id = {
    root: options.root || null,
    margin: options.rootMargin || ''
  };
  var existing = idList.find(function (obj) {
    return obj.root === id.root && obj.margin === id.margin;
  });
  var instance;

  if (existing) {
    instance = observers.get(existing);

    if (instance) {
      return instance;
    }
  }

  var elements = new Map();
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var callback = elements.get(entry.target);
      var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;

      if (callback && isVisible) {
        callback(isVisible);
      }
    });
  }, options);
  instance = {
    id: id,
    observer: observer,
    elements: elements
  };
  idList.push(id);
  observers.set(id, instance);
  return instance;
}

function observe(element, callback, options) {
  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements;

  elements.set(element, callback);
  observer.observe(element);
  return function unobserve() {
    elements["delete"](element);
    observer.unobserve(element); // Destroy observer when there's nothing left to watch:

    if (elements.size === 0) {
      observer.disconnect();
      observers["delete"](id);
      var index = idList.findIndex(function (obj) {
        return obj.root === id.root && obj.margin === id.margin;
      });

      if (index > -1) {
        idList.splice(index, 1);
      }
    }
  };
}

function useIntersection(_ref) {
  var rootRef = _ref.rootRef,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled;
  var isDisabled = disabled || !hasIntersectionObserver;

  var _useState = (0, _react).useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var _useState3 = (0, _react).useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      element = _useState4[0],
      setElement = _useState4[1];

  (0, _react).useEffect(function () {
    if (hasIntersectionObserver) {
      if (isDisabled || visible) return;

      if (element && element.tagName) {
        var unobserve = observe(element, function (isVisible) {
          return isVisible && setVisible(isVisible);
        }, {
          root: rootRef == null ? void 0 : rootRef.current,
          rootMargin: rootMargin
        });
        return unobserve;
      }
    } else {
      if (!visible) {
        var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function () {
          return setVisible(true);
        });
        return function () {
          return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
        };
      }
    }
  }, [element, isDisabled, rootMargin, rootRef, visible]);
  var resetVisible = (0, _react).useCallback(function () {
    setVisible(false);
  }, []);
  return [setElement, visible, resetVisible];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 6163:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TemplateContext = exports.GlobalLayoutRouterContext = exports.LayoutRouterContext = exports.AppRouterContext = void 0;

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(7294));

'use client';

var AppRouterContext = _react["default"].createContext(null);

exports.AppRouterContext = AppRouterContext;

var LayoutRouterContext = _react["default"].createContext(null);

exports.LayoutRouterContext = LayoutRouterContext;

var GlobalLayoutRouterContext = _react["default"].createContext(null);

exports.GlobalLayoutRouterContext = GlobalLayoutRouterContext;

var TemplateContext = _react["default"].createContext(null);

exports.TemplateContext = TemplateContext;

if (false) {}

/***/ }),

/***/ 1664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(7913)


/***/ }),

/***/ 2703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 2093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);



var debounce = function debounce(fn, time) {
  var timeout = void 0;

  return function () {
    var _this = this,
        _arguments = arguments;

    var functionCall = function functionCall() {
      return fn.apply(_this, _arguments);
    };

    clearTimeout(timeout);
    timeout = setTimeout(functionCall, time);
  };
};

// https://stackoverflow.com/questions/6860853/generate-random-string-for-div-id#6860916

var guidGenerator = (function () {
  var S4 = function S4() {
    return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
  };
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
});

function getHighest(elements) {
  var highest = 0;
  elements.forEach(function (el) {
    if (el.rect && el.rect.height > highest) {
      highest = el.rect.height;
    }
  });
  return highest;
}

function nextTriggerOnMount(_ref) {
  var rect = _ref.rect,
      mode = _ref.mode,
      prevOffset = _ref.prevOffset,
      position = _ref.position,
      direction = _ref.direction,
      width = _ref.width;

  if (mode !== 'chain') return false;
  switch (direction) {
    case 'toRight':
      return position.from > 0;
    case 'toLeft':
    default:
      return rect.width + position.from <= width;
  }
}

function getFromOffset(_ref) {
  var rect = _ref.rect,
      offset = _ref.offset,
      direction = _ref.direction;

  switch (direction) {
    case 'toRight':
      return offset - rect.width;
    case 'toLeft':
    default:
      return offset;
  }
}

function getFrom(_ref2) {
  var index = _ref2.index,
      rect = _ref2.rect,
      offset = _ref2.offset,
      width = _ref2.width,
      direction = _ref2.direction;

  if (index === 0) return offset;

  if (typeof offset === 'number') {
    return getFromOffset({ rect: rect, offset: offset, direction: direction });
  }

  switch (direction) {
    case 'toRight':
      return -rect.width;
    case 'toLeft':
    default:
      return width;
  }
}

function getTo(_ref3) {
  var rect = _ref3.rect,
      width = _ref3.width,
      direction = _ref3.direction;

  switch (direction) {
    case 'toRight':
      return width;
    case 'toLeft':
    default:
      return -rect.width;
  }
}

function getNext(_ref4) {
  var mode = _ref4.mode,
      from = _ref4.from,
      direction = _ref4.direction,
      rect = _ref4.rect,
      width = _ref4.width;

  var start = from || 0;

  switch (mode) {
    case 'await':
      switch (direction) {
        case 'toRight':
          return width;
        case 'toLeft':
        default:
          return -rect.width;
      }
    case 'smooth':
      switch (direction) {
        case 'toRight':
          return rect.width > width ? 0 : width - rect.width;
        case 'toLeft':
        default:
          return rect.width > width ? width - rect.width : 0;
      }
    case 'chain':
    default:
      switch (direction) {
        case 'toRight':
          return 0;
        case 'toLeft':
        default:
          return rect.width + start > width ? width - rect.width : width - rect.left - rect.width;
      }
  }
}

var getPosition = (function (_ref5) {
  var mode = _ref5.mode,
      index = _ref5.index,
      rect = _ref5.rect,
      offset = _ref5.offset,
      width = _ref5.width,
      direction = _ref5.direction;

  var from = getFrom({ index: index, rect: rect, offset: offset, width: width, direction: direction });
  var to = getTo({ rect: rect, width: width, direction: direction });
  return {
    from: from,
    to: to,
    next: getNext({ mode: mode, from: from, direction: direction, rect: rect, width: width })
  };
});

function getNextOffset(_ref) {
  var from = _ref.from,
      rect = _ref.rect,
      direction = _ref.direction;

  switch (direction) {
    case 'toRight':
      {
        return from;
      }
    case 'toLeft':
    default:
      {
        return from + rect.width;
      }
  }
}

function getStartOffset(_ref) {
  var offset = _ref.offset,
      rect = _ref.rect,
      direction = _ref.direction,
      width = _ref.width;

  if (offset === 'run-in') {
    switch (direction) {
      case 'toRight':
        return -rect.width;
      case 'toLeft':
      default:
        return width;
    }
  }
  if (typeof offset === 'string') {
    var offsetRelative = Number(offset.replace('%', ''));
    if (offsetRelative) return width / 100 * offsetRelative;
  }
  return offset;
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var TickerElement = function (_React$Component) {
  inherits(TickerElement, _React$Component);

  function TickerElement() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, TickerElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = TickerElement.__proto__ || Object.getPrototypeOf(TickerElement)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      children: _this.props.children({
        index: _this.props.index
      }),
      move: _this.props.move,
      position: { from: undefined, to: undefined, next: undefined },
      offset: _this.props.offset,
      rect: null
    }, _this.x = 0, _this.isMoving = false, _this.nextTriggered = false, _this.elementRef = react__WEBPACK_IMPORTED_MODULE_0__.createRef(), _this.raf = null, _this.componentDidMount = function () {
      _this.setPosition(true);
      _this.observer = new MutationObserver(_this.onMutation);
      _this.observer.observe(_this.elementRef.current, { characterData: true, childList: true, subtree: true });
    }, _this.componentWillUnmount = function () {
      _this.observer.disconnect();
    }, _this.onMutation = function () {
      _this.setPosition();
    }, _this.componentDidUpdate = function (prevProps, prevState) {
      if (!_this.x && prevState.position.from !== _this.state.position.from) {
        _this.x = _this.state.position.from;
        _this.elementRef.current.style.transform = 'translate3d(' + _this.x + 'px, 0, 0)';
      }
      if (_this.x !== _this.state.position.from && prevProps.prevRect && _this.props.prevRect && prevProps.prevRect.width !== _this.props.prevRect.width) {
        if (_this.props.offset) {
          _this.x = _this.x + (_this.props.offset - prevProps.offset);
        } else {
          _this.x = _this.x + (_this.props.prevRect.width - prevProps.prevRect.width);
        }
        _this.elementRef.current.style.transform = 'translate3d(' + _this.x + 'px, 0, 0)';
      }
      if (_this.props.move && !prevProps.start && _this.props.start) {
        _this.animate();
      }
      if (_this.props.start && !prevProps.move && _this.props.move) {
        _this.animate();
      }
      if (prevProps.move && !_this.props.move) {
        _this.isMoving = false;
        window.cancelAnimationFrame(_this.raf);
      }
    }, _this.setPosition = function (isMount) {
      var _this$props = _this.props,
          mode = _this$props.mode,
          width = _this$props.width,
          id = _this$props.id,
          onNext = _this$props.onNext,
          direction = _this$props.direction,
          index = _this$props.index,
          setRect = _this$props.setRect;


      var rect = _this.elementRef.current.getBoundingClientRect();
      if (rect.width === 0) return;

      var offset = _this.props.index === 0 ? getStartOffset({ offset: _this.props.offset, rect: rect, direction: direction, width: width }) : _this.props.offset;

      var position = getPosition({ mode: mode, rect: rect, index: index, offset: offset, width: width, direction: direction });

      setRect({
        index: _this.props.index,
        rect: rect,
        offset: offset,
        nextOffset: getNextOffset({ from: position.from, rect: rect, direction: direction })
      });

      if (isMount) {
        var nextTriggerOnMount$$1 = nextTriggerOnMount({ mode: mode, rect: rect, position: position, offset: offset, direction: direction, width: width });
        if (nextTriggerOnMount$$1) {
          onNext({
            id: id,
            index: index,
            rect: rect,
            nextOffset: getNextOffset({ from: position.from, rect: rect, direction: direction })
          });
        }
        if (!nextTriggerOnMount$$1 && (offset || index === 0)) {
          onNext({ id: id, index: index, rect: rect });
        }
        _this.nextTriggered = nextTriggerOnMount$$1;
      }

      _this.setState({
        rect: rect,
        offset: offset,
        position: position
      });
    }, _this.shouldTriggerNext = function () {
      if (_this.nextTriggered) return false;
      return _this.props.direction === 'toLeft' ? _this.x <= _this.state.position.next : _this.x >= _this.state.position.next;
    }, _this.triggerNext = function () {
      if (_this.shouldTriggerNext()) {
        // if (this.props.index === 5) console.log(this.x)
        _this.nextTriggered = true;
        _this.props.onNext({
          id: _this.props.id,
          index: _this.props.index,
          rect: _this.state.rect
        });
      }
    }, _this.shouldFinish = function () {
      switch (_this.props.direction) {
        case 'toRight':
          return _this.x >= _this.state.position.to;
        case 'toLeft':
        default:
          return _this.x <= _this.state.position.to;
      }
    }, _this.animate = function () {
      if (_this.isMoving) return;
      _this.isMoving = true;

      var prevTimestamp = null;

      var step = function step(timestamp) {
        if (!_this.isMoving) return;
        if (!_this.elementRef.current) return;

        var progress = prevTimestamp ? timestamp - prevTimestamp : 0;

        _this.x = _this.props.direction === 'toLeft' ? _this.x - progress / 100 * _this.props.speed : _this.x + progress / 100 * _this.props.speed;
        _this.elementRef.current.style.transform = 'translate3d(' + _this.x + 'px, 0, 0)';
        _this.triggerNext();

        if (_this.shouldFinish()) {
          _this.isMoving = false;
          prevTimestamp = null;
          _this.props.onFinish(_this.props.id);
        } else {
          prevTimestamp = timestamp;
          _this.raf = window.requestAnimationFrame(step);
        }
      };
      _this.raf = window.requestAnimationFrame(step);
    }, _this.render = function () {
      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        'div',
        {
          className: 'ticker__element',
          style: {
            willChange: 'transform',
            position: 'absolute',
            left: 0,
            top: 0,
            transform: 'translate3d(' + _this.x + 'px, 0, 0)'
          },
          ref: _this.elementRef
        },
        _this.state.children
      );
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  return TickerElement;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

TickerElement.propTypes = {
  children: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([prop_types__WEBPACK_IMPORTED_MODULE_1__.node, prop_types__WEBPACK_IMPORTED_MODULE_1__.func]).isRequired,
  direction: prop_types__WEBPACK_IMPORTED_MODULE_1__.string.isRequired,
  speed: prop_types__WEBPACK_IMPORTED_MODULE_1__.number.isRequired,
  id: prop_types__WEBPACK_IMPORTED_MODULE_1__.string.isRequired,
  index: prop_types__WEBPACK_IMPORTED_MODULE_1__.number.isRequired,
  mode: prop_types__WEBPACK_IMPORTED_MODULE_1__.string.isRequired,
  move: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool.isRequired,
  onNext: prop_types__WEBPACK_IMPORTED_MODULE_1__.func.isRequired,
  onFinish: prop_types__WEBPACK_IMPORTED_MODULE_1__.func.isRequired,
  setRect: prop_types__WEBPACK_IMPORTED_MODULE_1__.func.isRequired,
  start: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool.isRequired,

  offset: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([prop_types__WEBPACK_IMPORTED_MODULE_1__.number, prop_types__WEBPACK_IMPORTED_MODULE_1__.string]),
  prevRect: prop_types__WEBPACK_IMPORTED_MODULE_1__.object,
  width: prop_types__WEBPACK_IMPORTED_MODULE_1__.number
};
TickerElement.defaultProps = {
  offset: undefined,
  width: undefined,
  prevRect: null
};

var getDefaultState = function getDefaultState(offset, width) {
  return {
    elements: [{
      id: guidGenerator(),
      index: 0,
      height: 0,
      start: false,
      offset: offset,
      rect: null,
      prevRect: null
    }],
    width: width,
    height: 0
  };
};

var Ticker = function (_React$Component) {
  inherits(Ticker, _React$Component);

  function Ticker() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Ticker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Ticker.__proto__ || Object.getPrototypeOf(Ticker)).call.apply(_ref, [this].concat(args))), _this), _this.next = null, _this.state = getDefaultState(_this.props.offset), _this.tickerRef = react__WEBPACK_IMPORTED_MODULE_0__.createRef(), _this.dOnResize = debounce(function () {
      return _this.onResize();
    }, 150), _this.componentDidMount = function () {
      _this.setState({
        width: _this.tickerRef.current.offsetWidth,
        height: _this.props.height
      });
      window.addEventListener('resize', _this.dOnResize);
    }, _this.componentWillUnmount = function () {
      window.removeEventListener('resize', _this.dOnResize);
    }, _this.setRect = function (_ref2) {
      var index = _ref2.index,
          rect = _ref2.rect,
          offset = _ref2.offset,
          nextOffset = _ref2.nextOffset;

      _this.setState(function (prevState) {
        var elements = prevState.elements.map(function (el) {
          var newEl = el;
          if (el.index === index) newEl.rect = rect;
          // next element
          if (el.index === index + 1) {
            newEl.prevRect = rect;
            if (newEl.offset) {
              newEl.offset = nextOffset;
            }
          }
          return newEl;
        });
        return {
          elements: elements,
          height: _this.props.height ? prevState.height : getHighest(elements)
        };
      });
    }, _this.onResize = function () {
      if (!_this.tickerRef.current || _this.tickerRef.current.offsetWidth === _this.state.width) return;
      _this.setState(_extends({}, getDefaultState(_this.props.offset, _this.tickerRef.current.offsetWidth), {
        height: _this.props.height
      }));
    }, _this.onFinish = function (id) {
      _this.props.onFinish();
      _this.setState(function (prevState) {
        return {
          elements: prevState.elements.filter(function (el) {
            return el.id !== id;
          })
        };
      });
    }, _this.onNext = function (_ref3) {
      var id = _ref3.id,
          index = _ref3.index,
          rect = _ref3.rect,
          nextOffset = _ref3.nextOffset;

      _this.props.onNext(index);

      _this.setState(function (prevState) {
        return {
          elements: [].concat(toConsumableArray(prevState.elements.map(function (el) {
            var newEl = el;
            if (el.index === index) newEl.rect = rect;
            if (el.index === 0 || el.offset || newEl.index === index + 1) {
              newEl.start = true;
            }
            return newEl;
            // create new element
          })), [{
            id: guidGenerator(),
            index: prevState.elements[prevState.elements.length - 1].index + 1,
            height: 0,
            start: false,
            offset: nextOffset,
            rect: null,
            prevRect: rect
          }])
        };
      });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Ticker, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        'div',
        {
          className: 'ticker',
          ref: this.tickerRef,
          style: {
            position: 'relative',
            overflow: 'hidden',
            height: this.state.height && this.state.height + 'px'
          }
        },
        this.state.width && this.state.elements.map(function (el) {
          return react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            TickerElement,
            {
              key: el.id,
              id: el.id,
              index: el.index,
              start: el.start,
              offset: el.offset,
              prevRect: el.prevRect,

              direction: _this2.props.direction,
              mode: _this2.props.mode,
              move: _this2.props.move,
              speed: _this2.props.speed,

              onFinish: _this2.onFinish,
              onNext: _this2.onNext,
              setRect: _this2.setRect,
              width: _this2.state.width
            },
            _this2.props.children
          );
        })
      );
    }
  }]);
  return Ticker;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);

Ticker.propTypes = {
  children: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([prop_types__WEBPACK_IMPORTED_MODULE_1__.node, prop_types__WEBPACK_IMPORTED_MODULE_1__.func]).isRequired,

  direction: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  mode: prop_types__WEBPACK_IMPORTED_MODULE_1__.string,
  move: prop_types__WEBPACK_IMPORTED_MODULE_1__.bool,
  offset: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([prop_types__WEBPACK_IMPORTED_MODULE_1__.number, prop_types__WEBPACK_IMPORTED_MODULE_1__.string]),
  speed: prop_types__WEBPACK_IMPORTED_MODULE_1__.number,
  height: (0,prop_types__WEBPACK_IMPORTED_MODULE_1__.oneOfType)([prop_types__WEBPACK_IMPORTED_MODULE_1__.number, prop_types__WEBPACK_IMPORTED_MODULE_1__.string]),
  onNext: prop_types__WEBPACK_IMPORTED_MODULE_1__.func,
  onFinish: prop_types__WEBPACK_IMPORTED_MODULE_1__.func
};
Ticker.defaultProps = {
  offset: 0,
  speed: 5,
  direction: 'toLeft',
  mode: 'chain',
  move: true,
  height: undefined,
  onNext: function onNext() {},
  onFinish: function onFinish() {}
};

/* harmony default export */ __webpack_exports__["Z"] = (Ticker);
//# sourceMappingURL=index.es.js.map


/***/ })

}]);